import { createElementBlock, createElementVNode, defineComponent, normalizeClass, openBlock, withModifiers } from "vue";
//#region src/v2/blocks/request-block/components/RequestBodyViewToggle.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = { class: "text-c-3 text-xxs -my-1 mr-2 flex justify-center gap-0.5 rounded p-0.5" };
var _hoisted_2 = ["disabled", "title"];
var RequestBodyViewToggle_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "RequestBodyViewToggle",
	props: {
		modelValue: {},
		disabled: { type: Boolean }
	},
	emits: ["update:modelValue"],
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("button", {
				class: normalizeClass(["rounded px-1", __props.disabled ? "cursor-not-allowed opacity-50" : {
					"bg-b-3 text-c-1 cursor-default": __props.modelValue === "form",
					"hover:bg-b-3": __props.modelValue !== "form"
				}]),
				disabled: __props.disabled,
				title: __props.disabled ? "Fix the body to switch to the form view" : void 0,
				type: "button",
				onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.$emit("update:modelValue", "form"), ["stop"]))
			}, " Form ", 10, _hoisted_2), createElementVNode("button", {
				class: normalizeClass(["hover:bg-b-3 rounded px-1", { "bg-b-3 text-c-1 cursor-default": __props.modelValue === "raw" }]),
				type: "button",
				onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.$emit("update:modelValue", "raw"), ["stop"]))
			}, " Raw ", 2)]);
		};
	}
});
//#endregion
export { RequestBodyViewToggle_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=RequestBodyViewToggle.vue.script.js.map